<template>
  <v-dialog 
    :value="isOpen"
    persistent
    fullscreen
    content-class="image-browser video-player">
    <v-card>
      <v-layout column escalon-absolute-cover>
        <v-flex shrink>
          <video-player-header @closeModal="clearVideo"/>   
          <video-playback-toolbar 
            :isPlaying="isPlaying" 
            :isMuted="isMuted"
            :duration="duration" 
            :currentTime="currentTime" 
            :volume="volume"
            @play="play" 
            @pause="pause"
            @setCurrentTime="setCurrentTime"
            @setVolume="setVolume"
            @toggleVideoAudio="toggleVideoAudio"/>
        </v-flex>
        <v-flex video-viewer>
          <v-icon v-if="!hasPlayed" :style="iconStyle" :color="colorHex">fas fa-film</v-icon>
          <video 
            width="100%"
            height="100%"
            ref="video"
            loop
            @timeupdate="timeupdate"
            @loadedmetadata="loadedmetadata" >
            <source :src="videoSrc" type="video/mp4" ref="src"/>
          </video>
          <image-drawer v-if="!isKnowledgeCenterVideo" :currentExSrNo="videoExSrNo"/>
        </v-flex>
      </v-layout>
    </v-card>
</v-dialog>
</template>

<script>
import videoPlaybackToolbar from "./VideoPlaybackToolbar";
import videoPlayerHeader from "./VideoPlayerHeader";
import imageDrawer from "../imageBrowser/ImageDrawer";
import { mapGetters, mapMutations } from "vuex";
import { logDetailed } from "../../helpers/utils";

export default {
  name: "videoViewerDialog",
  components: {
    videoPlaybackToolbar,
    videoPlayerHeader,
    imageDrawer
  },
  data(){
    return {
      isPlaying: false,
      isMuted: false,
      duration: 0,
      currentTime: 0,
      width: 0,
      height: 0,
      volume: 0.5,
      hasPlayed: false
    }
  },
  computed: {
    ...mapGetters([
      "videoViewer", 
      "patient", 
      "videoPtSrNo",
      "videoExSrNo",
      "videoFileName",
      "isKnowledgeCenterVideo",
      "knowledgeCenterVideoSrc"
    ]),
    videoSrc() {
      if ((!this.videoPtSrNo || !this.videoExSrNo || !this.videoFileName) && !this.isKnowledgeCenterVideo) return "";
      if (!this.isKnowledgeCenterVideo) {
        let baseUrl = window.apiBaseURL.charAt(window.apiBaseURL.length - 1) == "/" ? window.apiBaseURL + "api/exam/video/?ptSrNo=" :  window.apiBaseURL + "/api/exam/video/?ptSrNo="
        let src =
          baseUrl +
          this.videoPtSrNo +
          "&exSrNo=" +
          this.videoExSrNo +
          "&fileName=" +
          this.videoFileName;
        return src;
      }
      else 
         return window.apiBaseURL.charAt(window.apiBaseURL.length - 1) == "/" ? window.apiBaseURL + this.knowledgeCenterVideoSrc : window.apiBaseURL + "/" + this.knowledgeCenterVideoSrc;
    },
    isOpen() {
      return !!this.videoViewer;
    },
    iconStyle() {
      return {
        "left": "50vw",
        "height": "77vh",
        "position": "absolute"
      };
    }
  },
  methods: {
    ...mapMutations(["clearVideoViewer", "clearKnowledgeCenterVideoSrc"]),
    play(){
      this.isPlaying = true;
      this.hasPlayed = true;
    },
    pause(){
      this.isPlaying = false;
    },
    timeupdate(e){
      this.currentTime = e.target.currentTime;
    },
    loadedmetadata(e){
      this.duration = e.target.duration;
      this.isPlaying = !e.target.paused;
      this.volume = 0.5;
      this.setVideoVolume();
      logDetailed("VideoViewerDialog", "loadedmetadata", "loaded video metadata")
    },
    setCurrentTime(time){
      this.$refs.video.currentTime = time;
    },
    setVolume(volume){
      this.volume = volume;
    },
    initializeVideo(){
      if (!this.$refs.video) return;
      this.$refs.video.pause();
      this.$refs.src.setAttribute("src", this.videoSrc);
      this.$refs.video.load();
      logDetailed("VideoViewerDialog", "loadedmetadata", "initialized video")
    },
    setVideoPlaying(){
      if (!this.$refs.video) return;
      if (this.isPlaying)
        this.$refs.video.play();
      else
        this.$refs.video.pause();
    },
    setVideoVolume(){
      if (!this.$refs.video) return;
      this.$refs.video.volume = this.volume;
    },
    toggleVideoAudio() {
      this.$refs.video.muted = !this.$refs.video.muted;
      this.isMuted = !this.isMuted;
    },
    clearVideo() {
      this.hasPlayed = false;
      if (this.isKnowledgeCenterVideo)
        this.clearKnowledgeCenterVideoSrc();
      this.clearVideoViewer();
    }
  },
  watch:{
    videoSrc(){
      this.hasPlayed = false;
      this.initializeVideo();
    },
    isPlaying(){
      this.setVideoPlaying();
    },
    volume(){
      this.setVideoVolume();
    }
  },
  mounted(){
    this.initializeVideo();
  }
}
</script>